import React from 'react';
import { Check, X } from 'lucide-react';

const features = [
  {
    category: 'Especialização',
    items: [
      {
        name: 'Treinada em legislação brasileira',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Base de jurisprudência nacional',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Doutrina jurídica brasileira',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      }
    ]
  },
  {
    category: 'Recursos Avançados',
    items: [
      {
        name: 'Análise de peças processuais',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Geração de documentos jurídicos',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Pesquisa jurídica inteligente',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Múltiplas IAs combinadas',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      }
    ]
  },
  {
    category: 'Segurança e Compliance',
    items: [
      {
        name: 'Dados processados no Brasil',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Conformidade com LGPD',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Confidencialidade garantida',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      }
    ]
  },
  {
    category: 'Personalização',
    items: [
      {
        name: 'Crie ferramentas do seu jeito',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Assistente próprio no Whatsapp',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      },
      {
        name: 'Assessoria de IA para empresas',
        support: { lawx: true, chatgpt: false, claude: false, gemini: false }
      }
    ]
  }
];

const ComparisonTable = () => {
  return (
    <div className="w-full" id="compare">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-white/10">
            <th className="p-4 text-left min-w-[200px]"></th>
            {/* Desktop: LawX logo */}
            <th className="p-4 text-center hidden md:table-cell">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-[#081428] rounded-2xl flex items-center justify-center mb-2 p-0 transition-transform duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(40,231,197,0.3)]">
                  <img
                    src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/bae752f2-e9b0-4924-58be-186e7e7c0c00/public"
                    alt="LawX"
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <span className="font-semibold">LawX</span>
              </div>
            </th>
            {/* Desktop: ChatGPT logo */}
            <th className="p-4 text-center hidden md:table-cell">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-2xl overflow-hidden mb-2 transition-transform duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(40,231,197,0.3)]">
                  <img 
                    src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/108a1afa-c11d-4ca3-0e7d-22e11f220100/public"
                    alt="ChatGPT"
                    className="w-full h-full object-cover"
                  />
                </div>
                <span className="font-semibold">ChatGPT</span>
              </div>
            </th>
            {/* Desktop: Claude logo */}
            <th className="p-4 text-center hidden md:table-cell">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-2 p-0 transition-transform duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(40,231,197,0.3)]">
                  <img 
                    src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/22379735-b872-4449-354d-fece1fee1700/public"
                    alt="Claude"
                    className="w-16 h-16 object-cover"
                  />
                </div>
                <span className="font-semibold">Claude</span>
              </div>
            </th>
            {/* Desktop: Gemini logo */}
            <th className="p-4 text-center hidden md:table-cell">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-2 transition-transform duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(40,231,197,0.3)]">
                  <img 
                    src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/5cd98bdc-0927-4f3b-ce36-5d9936d43300/public"
                    alt="Gemini"
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <span className="font-semibold">Gemini</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {/* MOBILE LOGOS ONCE at the top */}
          <tr className="md:hidden">
            <td colSpan={5} className="p-4">
              <div className="flex justify-around items-center">
                {/* LawX */}
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-[#081428] rounded-2xl flex items-center justify-center mb-2 p-0 transition-all duration-300 hover:scale-110 hover:shadow-[0_0_30px_rgba(40,231,197,0.3)] cursor-pointer">
                    <img
                      src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/bae752f2-e9b0-4924-58be-186e7e7c0c00/public"
                      alt="LawX"
                      className="w-12 h-12 object-contain"
                    />
                  </div>
                  <span className="font-semibold">LawX</span>
                </div>

                {/* ChatGPT */}
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-2xl overflow-hidden mb-2 transition-all duration-300 hover:scale-110 hover:shadow-[0_0_30px_rgba(40,231,197,0.3)] cursor-pointer">
                    <img 
                      src="https://imagedelivery.net/xVIHcLAprA3z5a44SkpIlA/108a1afa-c11d-4ca3-0e7d-22e11f220100/public"
                      alt="ChatGPT"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="font-semibold">ChatGPT</span>
                </div>
              </div>
            </td>
          </tr>

          {features.map((category, categoryIndex) => (
            <React.Fragment key={categoryIndex}>
              {/* Category row */}
              <tr className="border-b border-white/10 bg-white/5">
                <td colSpan={5} className="p-4 font-black text-lg bg-gradient-to-r from-[#4FC3F7] to-[#0B63F8] bg-clip-text text-transparent">
                  {category.category}
                </td>
              </tr>

              {category.items.map((item, itemIndex) => (
                <React.Fragment key={`${categoryIndex}-${itemIndex}`}>
                  {/* Desktop row */}
                  <tr className="border-b border-white/10 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_20px_rgba(40,231,197,0.1)] hidden md:table-row cursor-pointer">
                    <td className="p-4">{item.name}</td>
                    <td className="p-4 text-center">
                      {item.support.lawx ? (
                        <Check className="w-6 h-6 text-[#28E7C5] mx-auto" />
                      ) : (
                        <X className="w-6 h-6 text-red-500 mx-auto" />
                      )}
                    </td>
                    <td className="p-4 text-center">
                      {item.support.chatgpt ? (
                        <Check className="w-6 h-6 text-[#28E7C5] mx-auto" />
                      ) : (
                        <X className="w-6 h-6 text-red-500 mx-auto" />
                      )}
                    </td>
                    <td className="p-4 text-center">
                      {item.support.claude ? (
                        <Check className="w-6 h-6 text-[#28E7C5] mx-auto" />
                      ) : (
                        <X className="w-6 h-6 text-red-500 mx-auto" />
                      )}
                    </td>
                    <td className="p-4 text-center">
                      {item.support.gemini ? (
                        <Check className="w-6 h-6 text-[#28E7C5] mx-auto" />
                      ) : (
                        <X className="w-6 h-6 text-red-500 mx-auto" />
                      )}
                    </td>
                  </tr>

                  {/* Mobile row: no logos here */}
                  <tr className="border-b border-white/10 hover:bg-white/10 transition-all duration-300 hover:shadow-[0_0_20px_rgba(40,231,197,0.1)] md:hidden cursor-pointer">
                    <td className="p-4">
                      <div className="flex flex-col space-y-2">
                        <span className="font-medium">{item.name}</span>
                        <div className="flex items-center justify-center gap-20 mx-4">
                          <div className="flex items-center">
                            {item.support.lawx ? (
                              <Check className="w-5 h-5 text-[#28E7C5]" />
                            ) : (
                              <X className="w-5 h-5 text-red-500" />
                            )}
                          </div>
                          <div className="flex items-center">
                            {item.support.chatgpt ? (
                              <Check className="w-5 h-5 text-[#28E7C5]" />
                            ) : (
                              <X className="w-5 h-5 text-red-500" />
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
